import initLoggedShell from '@ep/tools/init.js';
import mountWebmanagerSiteContext from './siteContextMenu.js';
import channelAccountActionRegistry from './channelAccountActions.js';
import candidateDossierActionRegistry from './candidateDossierActions.js';
import boardActionRegistry from './boardActions.js';

let teardownSiteContext = null;

export default async function initLoggedPage() {
  globalThis.__EP_DATAGRID_ACTION_REGISTRY = {
    ...(globalThis.__EP_DATAGRID_ACTION_REGISTRY || {}),
    ...channelAccountActionRegistry,
    ...candidateDossierActionRegistry,
    ...boardActionRegistry,
  };

  teardownSiteContext?.();
  await initLoggedShell();
  teardownSiteContext = mountWebmanagerSiteContext();
}
